module.exports = __webpack_public_path__ + "static/media/m4.e42b1248.png";